import { Loader2, MapPin } from "lucide-react";

export const SearchProgress = ({ progress, etaSeconds }) => {
  if (!progress) return null;
  const { stage, done = 0, total = 0, city } = progress;
  const pct = total > 0 ? Math.min(99, 18 + Math.round((done / total) * 80)) : 12;

  return (
    <div
      data-testid="search-progress"
      className="absolute inset-0 z-[1100] flex items-center justify-center bg-white/70 p-4 backdrop-blur-sm"
    >
      <div className="w-[min(440px,92vw)] rounded-2xl border border-slate-200 bg-white p-6 shadow-xl jk-fade-up">
        <div className="flex items-center gap-2 text-emerald-700">
          <MapPin className="h-4 w-4" />
          <span className="text-base font-semibold">Söker i {city || "staden"}</span>
          <Loader2 className="ml-auto h-4 w-4 animate-spin text-emerald-500" />
        </div>

        <p data-testid="search-progress-stage" className="mt-2 text-sm text-slate-600">
          {stage}
          {total > 0 ? ` (${done} av ${total} hemsidor)` : ""}
        </p>

        <div className="mt-4 h-2.5 w-full overflow-hidden rounded-full bg-slate-100">
          <div
            data-testid="search-progress-bar"
            className="h-full rounded-full bg-emerald-500 transition-all duration-500 ease-out"
            style={{ width: `${pct}%` }}
          />
        </div>

        <p className="mt-2 text-xs text-slate-400">
          {etaSeconds != null && etaSeconds > 0
            ? `Ungefär ${etaSeconds}s kvar`
            : "Första sökningen på en ny stad kan ta en stund – resultatet sparas sedan."}
        </p>
      </div>
    </div>
  );
};
